export default defineNuxtRouteMiddleware(async (to) => {
  const { navigateToLocalized } = useRouterUtils()

  const id = to.params?.id
  const orderId = Array.isArray(id) ? id[0] : id
  if (!orderId) return navigateToLocalized('/my-orders/single-orders')

  const { activeTabs } = await useMyOrders()

  const tabNames = activeTabs.value.map(({ name }) => name)
  if (tabNames.includes(orderId)) return true

  const type = await useOrderType().getOrderType(String(orderId))
  if (!type) return create404Error()

  return navigateToLocalized(getOrderRoute(type, String(orderId)))
})
